import DocumentSourceDetailView from "./DocumentSourceDetailView";
import NoContentCard from "src/reusable/Sidebar/NoContentCard";
import { SideBarScroll } from "../ui/SideBarScroll";
import SourceDetailHeader from "./SourceDetailHeader";
import SourceDetailView from "./SourceDetailView";
import SourceListView from "./SourceListView";
import { useGetSourceDataRecord } from "src/views/datasets/services/DatasetServices";
import { useUIStore } from "../../stores/UIStore";

type SourceCardsListProps = {
  documentHeight: number;
  responseSources: any[];
  detailSourceViewSdrId: number | null;
  detailSourceViewSourceId: number | null;
  setDetailSourceViewSdrId: React.Dispatch<React.SetStateAction<number | null>>;
  setDetailSourceViewSourceId: React.Dispatch<
    React.SetStateAction<number | null>
  >;
};

const SourceCardsList = ({
  responseSources,
  detailSourceViewSourceId,
  detailSourceViewSdrId,
  setDetailSourceViewSdrId,
  setDetailSourceViewSourceId,
  documentHeight,
}: SourceCardsListProps) => {
  const { rightSidebar, openDetailedSourceView } = useUIStore();

  const isDetailedSourceViewOpen = rightSidebar.isDetailedSourceViewOpen;

  const { data: sourceDataRecord } = useGetSourceDataRecord(
    detailSourceViewSdrId,
  );

  const isDocument = Boolean(sourceDataRecord?.data?.file_name);

  const isSourceDetailOpen =
    isDetailedSourceViewOpen && detailSourceViewSdrId && !isDocument;
  const isDocumentSourceDetailOpen =
    isDetailedSourceViewOpen && detailSourceViewSdrId && isDocument;

  const handleSetDetailSourceViewId = (
    sdrId: number | null,
    sourceId: number | null,
  ) => {
    setDetailSourceViewSdrId(sdrId);
    setDetailSourceViewSourceId(sourceId);
    openDetailedSourceView({ id: sdrId, sourceId });
  };

  return (
    <>
      {isDetailedSourceViewOpen && (
        <SourceDetailHeader
          sdrId={detailSourceViewSdrId}
          sourceId={detailSourceViewSourceId}
          responseSources={responseSources}
        />
      )}
      <SideBarScroll>
        {!responseSources.length && (
          <NoContentCard
            title="No Sources Identified"
            description="Source material references will appear here once identified in the responses."
          />
        )}

        {!isDetailedSourceViewOpen && (
          <SourceListView
            responseSources={responseSources}
            onSourceClick={handleSetDetailSourceViewId}
          />
        )}

        {/* Make this a dropdown under the sourcelistview */}
        {isSourceDetailOpen && (
          <SourceDetailView sdrId={detailSourceViewSdrId} />
        )}

        {/* Make this a dropdown under the sourcelistview */}
        {isDocumentSourceDetailOpen && (
          <DocumentSourceDetailView
            sdrId={detailSourceViewSdrId}
            sourceId={detailSourceViewSourceId}
            responseSources={responseSources}
            documentHeight={documentHeight}
          />
        )}
      </SideBarScroll>
    </>
  );
};

export default SourceCardsList;
